import React, { useRef, useEffect } from 'react';
import './BackgroundVideo.css';

const BackgroundVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Function to start playing when any user interaction happens
    const attemptPlay = () => {
      if (videoRef.current) {
        videoRef.current.play().catch(error => {
          // Silently handle the error - we'll try again on next interaction
          console.log("Autoplay prevented, waiting for interaction");
        });
      }
    };

    // Try to play immediately
    attemptPlay();

    // Add event listeners for various user interactions
    const events = ['click', 'touchstart', 'keydown', 'scroll', 'mousemove'];
    const playVideoOnInteraction = () => {
      attemptPlay();
      // Remove all event listeners after first interaction
      events.forEach(event => {
        document.removeEventListener(event, playVideoOnInteraction);
      });
    };

    // Add all event listeners
    events.forEach(event => {
      document.addEventListener(event, playVideoOnInteraction);
    });

    // Cleanup function
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, playVideoOnInteraction);
      });
    };
  }, []);

  return (
    <div className="background-video-container">
      <video 
        ref={videoRef}
        className="background-video" 
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
      >
        <source src="/assets/hero.webm" type="video/webm" />
      </video>
    </div>
  );
};

export default BackgroundVideo; 